module.exports = "https://static.energy5.com/_next/static/images/batteryBg-dd4b8c00dbd5f5bd574a6730ab63e7da.webp";